import { Helmet } from 'react-helmet-async';

const DEFAULT_DESCRIPTION =
  'pingr-notify is our internal notification platform for delivering multi-channel notifications (in-app, email, push, SMS, chat) across products.';

type Props = {
  title?: string;
  description?: string;
};

export function PageMeta({ title, description }: Props) {
  const pageTitle = title ? `${title} | pingr-notify` : 'pingr-notify';
  const pageDescription = description || DEFAULT_DESCRIPTION;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
    </Helmet>
  );
}
